<template>
  <div>
    <div
      class="profile-field__title"
      :class="{
        'profile-field__title--required': field.required,
      }"
    >
      Портфолио
    </div>

    <transition-group v-if="links.length" tag="div" name="fade" class="links">
      <div v-for="(link, i) in links" :key="link.id" class="link">
        <c-input
          v-model="link.link"
          class="text"
          floating-label="Ссылка на портфолио"
          clearable
          :required="error && error.links && error.links[i]"
          :required-message="error && error.links && error.links[i]"
        />
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Удалить',
            placement: 'top',
          }"
          class="remove"
          size="iconic"
          :icon="{ icon: 'trash', color: 'secondary' }"
          @click="removeLink(link)"
        />
      </div>
    </transition-group>

    <div v-if="preview" class="preview">
      <div class="file-preview">
        <file-preview :type="'doc'" name="Документ 1.docx" data-type="link"></file-preview>
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Удалить',
            placement: 'top',
          }"
          :disabled="true"
          class="file-preview__remove"
          size="iconic"
          icon="trash"
        />
      </div>
    </div>

    <div class="wrapper">
      <c-button
        :icon="{ icon: 'plus', color: 'primary' }"
        label="Добавить ссылку"
        class="add-link"
        :disabled="preview || hasEmptyLinks"
        size="small"
        @click="addLink"
      />

      <c-button
        v-if="!files.length && !fileLinks.length"
        :icon="{ icon: 'plus', color: 'primary' }"
        label="Добавить файл"
        class="add-file"
        :disabled="preview"
        size="small"
        @click="addFile"
      />
    </div>

    <file-loader
      ref="loader"
      v-model="files"
      class="files"
      :style="{ display: files.length || fileLinks.length ? '' : 'none' }"
      :links="fileLinks"
      format="images,pdf,docs"
      actions="loadFiles,preview"
      :limit="field.maxFiles || 10"
      :disabled="preview"
      @changeLinks="updateFileLinks"
    ></file-loader>

    <error-feedback v-if="error && error.common" :text="error && error.common" />
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";
import CInput from "@/components/controls2/Input";
import FilePreview from "@/components/file-preview";
import FileLoader from "@/components/file-loader";
import ErrorFeedback from "@/components/error-feedback";

import { getUnique } from "@/utils/number/unique";

export default {
  components: { CButton, CInput, FilePreview, FileLoader, ErrorFeedback },
  props: ["field", "value", "preview", "editable", "error"],
  data() {
    return {
      inited: false,
      links: [],
      files: [],
      fileLinks: [],
    };
  },

  computed: {
    hasEmptyLinks() {
      return this.links.some((link) => !link.link.trim());
    },
  },

  watch: {
    files() {
      this.updateValue();
    },
    links: {
      handler() {
        this.updateValue();
      },
      deep: true,
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      const { files, oldFiles, value: fieldValue } = value;

      if (!fieldValue) {
        this.links = [];
      } else {
        const currentLinks = this.links.map((link) => link.link);
        const newLinks = fieldValue.links.map((link) => link.link);

        if (JSON.stringify(currentLinks) !== JSON.stringify(newLinks)) {
          this.links = (fieldValue.links || []).map((item) => ({ id: getUnique(), link: item.link.toString() }));
        }
      }

      if (!files || (!files.length && this.files.length)) {
        if (this.$refs.loader) {
          this.$refs.loader.clearFiles();
        }
      }

      const currentFileLinks = this.fileLinks.map((link) => link.id);
      const newFileLinks = (oldFiles || []).map((file) => file.id);

      if (JSON.stringify(currentFileLinks) !== JSON.stringify(newFileLinks)) {
        this.fileLinks = oldFiles || [];
      }
      
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateFileLinks(value) {
      this.fileLinks = value;
      this.updateValue();
    },
    updateValue() {
      this.$emit("input", {
        files: this.files,
        oldFiles: this.fileLinks,
        value: {
          links: this.links.map((link) => ({ link: link.link })),
        },
      });
      
      if (this.inited) this.$emit("change");
    },
    addLink() {
      this.links = [...this.links, { id: getUnique(), link: "" }];
    },
    removeLink(link) {
      this.links = this.links.filter((item) => item.id !== link.id);
    },
    addFile() {
      this.$refs.loader.chooseFiles();
    },
  },
};
</script>

<style lang="scss" scoped>
.add-link,
.add-file {
  display: inline-flex;
  margin-right: 10px;
}
.preview {
  margin-bottom: 20px;
  display: flex;
}
.file-preview {
  position: relative;

  &__remove {
    position: absolute;
    right: -30px;
    top: -4px;
  }
}
.links {
  margin-bottom: 24px;
}
.link {
  display: flex;
  width: 100%;
  max-width: 605px;
  &:not(:last-child) {
    margin-bottom: 20px;
  }
  .text {
    flex-grow: 1;
  }
  .remove {
    margin-left: 30px;
    margin-top: 25px;
  }
  /deep/ {
    .c-input {
      padding-top: 6px;
    }
  }
}
.files {
  margin-top: 25px;
}
</style>
